import { useQuery } from "@apollo/client";
import { GAMES_WITH_ASSIGNMENT } from "../../graphql/games";
import { GameItem } from "../../components/ui/gameItem";
import { useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";
import useMainStore from "../../store/mainState";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ArrowRight } from "../../assets/icons/arrowRight.svg";

export const GameWithCategories = ({ title, categoryType="", comment="", searchText="" }: any) => {
    const { t } = useTranslation();
    const { environment, labelData, setActiveSubItem } = useMainStore();
    const navigate = useNavigate();

    let variables: any = {
        labelId: +labelData?.id,
        environmentId: environment?.id,
        isActive: true,
        first: 100,
        after: 0,
    }
    if(categoryType && !searchText){
        variables.categoryType = categoryType;
    }
    if(comment){
        variables.comment = comment;
    }
    if(searchText){
        variables.search = searchText;
    }

    const { data: gamesDataWithAssignment, loading: loadGamesWithAssignment, error: loadGamesWithAssignmentError, refetch: refetchGamesWithAssignment } = useQuery(GAMES_WITH_ASSIGNMENT, {
        fetchPolicy: 'cache-and-network',
        variables,
        skip: !labelData?.id || !environment?.id,
    });

    const games = gamesDataWithAssignment?.gamesWithAssignment?.games || [];

    // Hide section if no games
    if (!loadGamesWithAssignment && games.length === 0) return null;

    return (
        <div className="mt-[30px]">
            <div className="flex items-center justify-between mb-[14px]">
                <button
                    onClick={() => { if (categoryType) { setActiveSubItem(categoryType); navigate('/casino'); } }}
                    className="flex items-center gap-[10px] group"
                >
                    <div className="w-[3px] h-[20px] bg-gradient-to-b from-[#4DBDFF] to-[#0086D3] rounded-full"></div>
                    <h1 className="text-[15px] lg:text-[20px] font-bold text-white tracking-tight group-hover:text-[#4DBDFF] transition-colors duration-200">{title}</h1>
                    {comment && <span className="text-[10px] font-bold text-[#0086D3] bg-[#0086D3]/10 px-[8px] py-[2px] rounded-[6px] uppercase tracking-wider">{comment}</span>}
                </button>
                {categoryType && (
                    <button
                        onClick={() => { setActiveSubItem(categoryType); navigate('/casino'); }}
                        className="flex items-center gap-[6px] text-[12px] lg:text-[14px] font-semibold text-white/40 hover:text-[#4DBDFF] transition-colors duration-200 group"
                    >
                        {t('mainScreen.seeAll')}
                        <ArrowRight className="w-[14px] h-[14px] [&_*]:fill-current transition-transform duration-200 group-hover:translate-x-[3px]" />
                    </button>
                )}
            </div>
            <div className="flex flex-row overflow-x-auto scrollbar-hide">
                {games.map((game: any) => (
                    <GameItem game={game} key={game.id} />
                ))}
            </div>
        </div>
    )
}
